/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardPrizePool } from './LeaderboardPrizePool';
import {
    LeaderboardPrizePoolFromJSON,
    LeaderboardPrizePoolFromJSONTyped,
    LeaderboardPrizePoolToJSON,
    LeaderboardPrizePoolToJSONTyped,
} from './LeaderboardPrizePool';

/**
 * 
 * @export
 * @interface JoinLeaderboardResponse
 */
export interface JoinLeaderboardResponse {
    /**
     * 
     * @type {boolean}
     * @memberof JoinLeaderboardResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JoinLeaderboardResponse
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof JoinLeaderboardResponse
     */
    rank?: number | null;
    /**
     * 
     * @type {LeaderboardPrizePool}
     * @memberof JoinLeaderboardResponse
     */
    prizePool?: LeaderboardPrizePool;
}

/**
 * Check if a given object implements the JoinLeaderboardResponse interface.
 */
export function instanceOfJoinLeaderboardResponse(value: object): value is JoinLeaderboardResponse {
    return true;
}

export function JoinLeaderboardResponseFromJSON(json: any): JoinLeaderboardResponse {
    return JoinLeaderboardResponseFromJSONTyped(json, false);
}

export function JoinLeaderboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinLeaderboardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'rank': json['rank'] == null ? undefined : json['rank'],
        'prizePool': json['prizePool'] == null ? undefined : LeaderboardPrizePoolFromJSON(json['prizePool']),
    };
}

export function JoinLeaderboardResponseToJSON(json: any): JoinLeaderboardResponse {
    return JoinLeaderboardResponseToJSONTyped(json, false);
}

export function JoinLeaderboardResponseToJSONTyped(value?: JoinLeaderboardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'rank': value['rank'],
        'prizePool': LeaderboardPrizePoolToJSON(value['prizePool']),
    };
}

